import AWS from 'aws-sdk'
import { IdentityPoolId } from '../config'

const fetchUnauthCredentials = (credentials) => {
    return new Promise( (resolve, reject) => {
        if(!credentials) {

            let credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId
            })

            credentials.refresh((err) => {
                if(err) reject(err);
                else resolve(credentials);
            })

        }
        else {
            resolve(credentials);
        }
    })
}
const fetchAppartments = (credentials, TableName) => {
    return new Promise( (resolve, reject) => {

        fetchUnauthCredentials(credentials).then( credentials => {
            console.log(credentials)
            const dynamo = new AWS.DynamoDB.DocumentClient({credentials})
            dynamo.scan({
                TableName
            }, (err, res) => {
                if(err) reject(err);
                else resolve(res);
            })
        })

    })
}

const updateAppartment = (credentials, TableName, entity) => {
    return new Promise( (resolve, reject) => {

        fetchUnauthCredentials(credentials).then( credentials => {
            const dynamo = new AWS.DynamoDB.DocumentClient({credentials})
            dynamo.put({
                TableName,
                Item: entity
            }, (err, res) => {
                if(err) reject(err);
                else resolve(res);
            })
        })

    })
}

export {
    fetchAppartments,
    updateAppartment
}



// WEBPACK FOOTER //
// ./src/api/appartments.js